import { useEffect, useState } from 'react';
import { size } from '../../features/Theme/domain/breakpoints';

const mql = window.matchMedia(`(max-width: ${size.tabletMin - 1}px)`);

export function useIsMobile() {

	const [isMobile, setIsMobile] = useState(window.innerWidth < size.tabletMin);

	useEffect(() => {

		const onChange = () => {
			setIsMobile(window.innerWidth < size.tabletMin);
		};

		mql.addEventListener('change', onChange);

		return () => {
			mql.removeEventListener('change', onChange);
		};
	}, [isMobile]);

	return isMobile;
}